import "./cw.scss";
const CWLayout = ({ children }) => {
  return <div className="container-main container-cw">{children}</div>;
};

export default CWLayout;
